if (!window.customElements.get('collection-read-more')) {
  class CollectionReadMore extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.collection-extended__toggle');
      this.content = this.querySelector('.collection-extended__content');

      if (!this.button || !this.content) return;

      this.onClick = () => this.setExpanded(!this.classList.contains('is-expanded'));
      this.button.addEventListener('click', this.onClick);

      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      this.measure();
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.onClick);
      this.resizeObserver?.disconnect();
    }

    setExpanded(expanded) {
      this.classList.toggle('is-expanded', expanded);
      this.button.setAttribute('aria-expanded', String(expanded));

      if (!expanded && this.getBoundingClientRect().top < 0) {
        this.scrollIntoView({ block: 'start' });
      }
    }

    measure() {
      if (this.classList.contains('is-expanded')) return;

      this.classList.remove('is-short');
      const blocks = this.content.querySelector('.metafield-rich_text_field') || this.content;
      const first = blocks.firstElementChild;
      const overflows = blocks.children.length > 1 || (first && first.scrollHeight > first.clientHeight + 1);

      this.classList.toggle('is-short', !overflows);
      this.button.hidden = !overflows;
    }
  }

  window.customElements.define('collection-read-more', CollectionReadMore);
}
